import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PHONE_COUNTRIES, dialForIso } from "@/lib/phoneCountries";

// Champ téléphone international : sélecteur pays (indicatif) + numéro local.
// Renvoie via onChange le numéro E.164 complet (dial + local) et l'ISO du pays.
export default function PhoneField({ country, local, onCountryChange, onLocalChange, testid = "phone" }) {
  const dial = dialForIso(country);
  return (
    <div className="flex gap-2">
      <Select value={country} onValueChange={onCountryChange}>
        <SelectTrigger data-testid={`${testid}-country`} className="h-11 w-[130px] shrink-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {PHONE_COUNTRIES.map((c) => (
            <SelectItem key={c.iso} value={c.iso} data-testid={`${testid}-country-${c.iso}`}>
              <span className="mr-1">{c.flag}</span> {c.iso} {c.dial}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="relative flex-1">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">{dial}</span>
        <Input
          type="tel"
          data-testid={`${testid}-local`}
          value={local}
          onChange={(e) => onLocalChange(e.target.value.replace(/[^\d]/g, ""))}
          placeholder="612345678"
          className="h-11 pl-14"
        />
      </div>
    </div>
  );
}

// Construit le numéro E.164 à partir de l'ISO pays et du numéro local (sans 0 initial).
export const buildE164 = (country, local) => {
  const dial = dialForIso(country);
  let n = (local || "").replace(/[^\d]/g, "");
  if (n.startsWith("0")) n = n.slice(1);
  return dial && n ? `${dial}${n}` : "";
};
